import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// POST /ajax/sso/generate_sso_url
export const generateSsoUrl = async (payload: Object): Promise<any> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/sso/generate_sso_url`, payload)
      .then(response => {
        resolve(Util.Obj.keysToCamel(response.data))
      })
      .catch(err => {
        reject(err.responseText)
      })
  })
}
